import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect,MultiSelect } from 'vue-search-select';
import DatePicker from 'vue2-datepicker';
import Information from './../Information';
import dataUpload from './../dataUpload';
import BookingService from './../../../services/cargobooking.service';
import LRCopy from './../LRCopy';
import printmps from './../printmps';
import CONSTANT from './../../../../shared/constants/constant';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import pdfMake from "pdfmake/build/pdfmake";
import htmlToPdfmake from "html-to-pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Report from './../../../../report/services/report.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import Printd from 'printd'
import VueBarcode from 'vue-barcode';
import Multiselect from 'vue-multiselect'
import iptracker from '../../../../../views/components/commonfunction/iptracker';
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import Util from './../../../../shared/util/util';
import moment from 'moment';
export default {
  name: 'Createbookingtype',
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
    MultiSelect,
    Treeselect,
    dataUpload,
    Information,
    'barcode': VueBarcode,
    LRCopy,
    printmps,
    Multiselect,
    iptracker
  },
  props: ['selectedEditRowData','Clientlist'],
  data: function() {
    return {
      awbNo :'',
      NonDOX :'',
      DOX :'',
      credit :'',
      client :null,
      businessaccountname:'',
      clientbusinessdetailid:'',
      clientbusinessaccountid:'',
      Status :CONSTANT.BOOKING_STATUS[0],
      pushmanifestdataflag : '',
      bookingid : '',
      isLoading: false,
      PrintMPSModal: false,
      PrintAWBModal: false,
      FtcModal:false,
      showFlag: false,
      CompanyShortNameArr:[],
      ActiveContract:"",
      disableFileds: false,
      bookingData: JSON.parse(JSON.stringify(this.selectedEditRowData)),
      copyformat:'',
      showLRFlag:false,
      showMPSFlag:false,
      userRoleFlag:'',
      uploadFile:'',
      filename:'',
      uploadedDoc:'',
      allowimageupload:false,
      showCashMemoButton:false,
      downloadmessage:"(Click on the download icon to download)",
      userdetail:{},
      LRCopyawbdata:null,
      checkflag:false,
      checked: false,
      openViewRateCard : false,
      rateCardData:'',
      totalcharges:'',
      gst:''
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userdetail = userdetail;
    this.userName = userdetail.email;
    this.hubname = userdetail.currentHubName;
  	this.hubid = userdetail.hubID[0];
  	this.userid = userdetail.userid;
  	this.useremail = userdetail.email;
    this.userRoleFlag = (userdetail.rolename[0] == "Hub Executive" || userdetail.rolename[0] == "Hub Incharge" || userdetail.rolename[0] == "Hub Manager" || userdetail.rolename[0] == "TSP BA Admin") ? 1:2;
    if(this.Clientlist.length==0){
      this.getCompanyShortName();
    }
    if(this.bookingData.id){
      this.bookingid = this.bookingData.id;
      this.awbNo = this.bookingData.awbnumber;
      this.client = {
        id: this.bookingData.clientbusinessaccountid,
        label: this.bookingData.clientname,
        ContractId: this.bookingData.activecontract,
        CompanyName: this.bookingData.businessaccountname,
        ClientId: this.bookingData.clientid,
        ClientBusinessAccountId : this.bookingData.clientbusinessaccountid,
        ClientBusinessDetailId :  this.bookingData.clientbusinessdetailid,
      }
      this.Status = CONSTANT.BOOKING_STATUS[this.bookingData.status];
      this.ActiveContract = this.bookingData.activecontract;
      this.businessaccountname = this.bookingData.businessaccountname;
      this.clientbusinessdetailid = this.bookingData.clientbusinessdetailid;
      this.clientbusinessaccountid = this.bookingData.clientbusinessaccountid;
      this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
      this.disableFileds = true;
      await this.setRateCardData();
    }
    if (this.bookingData.bookingmode == 'To Pay') {
      this.getFTCCashmemoDetails()
    }
  },
  methods: {
    async getCompanyShortName(){
     try {
       let InputPayload = {};
       var CompanyShortList = [];
       let result = await ClientService.GetClientListByActiveContracts(InputPayload)
       CompanyShortList = result.data.data.rows;
       for (var i = 0; i < CompanyShortList.length; i++) {
         this.Clientlist.push({
           'id': CompanyShortList[i].clientbusinessaccountid,
           'label': CompanyShortList[i].clientshortname,
           'ContractId': CompanyShortList[i].id,
           'CompanyName': CompanyShortList[i].clientcompanyname,
           'ClientId' : CompanyShortList[i].clientid,
           'ClientBusinessAccountId' : CompanyShortList[i].clientbusinessaccountid,
           'ClientBusinessDetailId' :  CompanyShortList[i].clientbusinessdetailid
         })
       }
     } catch(err){
       console.log(err);
     }
   },
    selectClient(data){
      if(data){
        this.ActiveContract = data.ContractId;
        this.businessaccountname = data.CompanyName;
        this.clientbusinessdetailid = data.ClientBusinessDetailId;
        this.clientbusinessaccountid = data.ClientBusinessAccountId;
        this.disableFileds = true;
        this.$refs.moveToNext.getSKUList(data.ClientId, data.ClientBusinessAccountId, this.ActiveContract);
        this.$refs.moveToNext.getClientUOM(data.ClientId, data.ClientBusinessAccountId);
      }
    },
  	selectCheckbox(){
      if(this.awbNo){
        let awbno = this.awbNo.trim();
        this.awbNo = awbno.toUpperCase();
   	    console.log("data",this.awbNo);
      }
  	},
    UploadData(){
       this.showFlag = true;
    },
    refreshPage(){
      this.isLoading = true;
      this.client = null;
      this.ActiveContract = '';
      this.bookingid = '';
      this.awbNo = '';
      this.bookingData = [];
      this.disableFileds = false;
	    this.checked = false;
      this.isLoading = false;
      this.Status = CONSTANT.BOOKING_STATUS[0];
      this.$refs.moveToNext.resetdata();
    },
	  async verifyawbseries(routemode, awb,awbSeries) {
	  let awbnumber = awb.toUpperCase();
      if (awbnumber.length >= 10 && awbnumber.length <= 16) {
        if (routemode == "Air" && awbnumber) {
  		    let tempAir = awbSeries.find(i => i.key === 'AIRSERIES');
          let airAWB = tempAir.value;
          let airAwbNumber = airAWB.join(', ');
          let message = "<div style='padding-top:20px;'>AWB Number should start with</p></div>";
          let tempawb = airAWB.some((word) => awbnumber.startsWith(word));
          if (!tempawb) {
            this.$fire({
              html: message  +" <b>" + `${airAwbNumber}` + "</b>" + " as Route Mode <b>Air</b> is selected",
              width: 500,
              textalign: "left",
            });
            return false;
          }
          return awbnumber;
        } else if (routemode == "Surface" && awbnumber) {
  		      let tempsurface = awbSeries.find(i => i.key === 'SURFACESERIES');
            let surfaceAWB = tempsurface.value;
  		      let surfaceAwbNumber = surfaceAWB.join(', ');
            let message =
            "<div style='padding-top:20px;'>AWB Number should start with <b>"+ surfaceAwbNumber + "</b> as Route Mode <b>Surface</b> is selected</p></div>";
            let tempawb = surfaceAWB.some((word) => awbnumber.startsWith(word));
            if (!tempawb) {
              this.$fire({
                html: message,
                width: 500,
                textalign: "left",
              });
              return false;
            }
          return awbnumber;
        }
    } else {
      this.$alert("AWB Number minimum length should be 10", "", "error");
      return false;
    }
	},
    async saveServiceability(inputPayload,awbSeries){
      try {
        this.isLoading = true;
    		if(this.awbNo){
    		  let isvalid = await this.verifyawbseries(inputPayload.RouteMode,this.awbNo,awbSeries)
    		  if(!isvalid){
    			this.isLoading = false;
    			return false;
    		  }
    		  inputPayload.AWB = this.awbNo
    		}else if(this.checked){
    		  this.isLoading = false;
    		  this.$alert("Please enter AWB Number", "", "error");
    		  return false;
    		}
        let result = await BookingService.saveServiceability(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.awbNo = this.bookingData.awbnumber;
		      this.checked = false;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          this.Status = CONSTANT.BOOKING_STATUS[this.bookingData.status];
          document.activeElement.blur();
          let location;
          this.$alertify.success("Recorded Successfully");
          this.$refs.moveToNext.childMethod('subtab',2, this.client.ClientId, this.bookingData.pickuppincode,location,this.clientbusinessaccountid);
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async savePickupLocation(inputPayload,awbSeries){
      try {
        this.isLoading = true;
        let editPickupLocation = inputPayload.editPickupLocation
        delete inputPayload.editPickupLocation;
    		if(this.bookingData.bookingmethod.toLowerCase() == 'web' && this.bookingData.bookingstatus.toLowerCase() == 'pending'){
    		  if(this.awbNo){
    			let isvalid = await this.verifyawbseries(inputPayload.RouteMode,this.awbNo,awbSeries)
    			if(!isvalid){
    				this.isLoading = false;
    				return false;
    			}
    			inputPayload.AWB = this.awbNo
    		  }else if(this.checked){
    			this.isLoading = false;
    			this.$alert("Please enter AWB Number", "", "error");
    			return false;
    		  }
    		}
        let result = await BookingService.savePickupLocation(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          //  this.awbNo = this.bookingData.awbnumber;
		      this.checked = false;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          this.Status = CONSTANT.BOOKING_STATUS[this.bookingData.status];
          let location = {
            id: this.bookingData.pickuplocationname,
            label: this.bookingData.pickuplocationname,
            mobile: this.bookingData.pickupmobile,
            telephone: this.bookingData.pickuptelephone,
            email: this.bookingData.pickupemail,
            address: this.bookingData.pickupaddress,
            gstno: this.bookingData.pickupgst
          };
          let clientid = this.bookingData.clientid;
          let pincode = this.bookingData.pickuppincode;
          document.activeElement.blur();
          this.$alertify.success("Recorded Successfully");
          if(this.bookingData.bookingmethod == "Upload" && this.bookingData.totalvolumetricweight == null){
            this.$refs.moveToNext.childMethod('subtab',3,clientid,pincode,location,this.clientbusinessaccountid);
          }else if(editPickupLocation == false && this.bookingData.totalshipmentvalues != null){
            this.$refs.moveToNext.childMethod('maintab',2);
          }
          else{
            this.$refs.moveToNext.childMethod('subtab',3,clientid,pincode,location,this.clientbusinessaccountid);
          }
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveShipmentDetails(inputPayload,awbSeries){
      try {
        this.isLoading = true;
    		if(this.awbNo){
    		  let isvalid = await this.verifyawbseries(inputPayload.RouteMode,this.awbNo,awbSeries)
    		  if(!isvalid){
    			this.isLoading = false;
    			return false;
    		  }
    		  inputPayload.AWB = this.awbNo
    		}else if(this.checked){
    		  this.isLoading = false;
    		  this.$alert("Please enter AWB Number", "", "error");
    		  return false;
    		}
        let result = await BookingService.saveShipmentDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
        //  this.awbNo = this.bookingData.awbnumber;
		      this.checked = false;
		      this.checkflag = true;
          this.Status = CONSTANT.BOOKING_STATUS[this.bookingData.status];
          this.pushBookingDatatoManifest(this.bookingData.id);
          document.activeElement.blur();
          this.$alertify.success("Recorded Successfully");
          this.$refs.moveToNext.childMethod('maintab',2);
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveShipmentTotal(inputPayload){
      try {
        this.isLoading = true;
        let result = await BookingService.saveShipmentTotal(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          document.activeElement.blur();
          this.$alertify.success("Recorded Successfully");
          if(this.bookingData.pickuplocationname !=null){
            this.$refs.moveToNext.childMethod('maintab',2);
          }
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveShipmentDimensions(inputPayload){
      try {
        this.isLoading = true;
        let result = await BookingService.saveShipmentDimensions(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          document.activeElement.blur();
          this.$alertify.success("Recorded Successfully");
          this.$refs.moveToNext.childMethod('maintab',2);
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveConsigneeDetails(inputPayload){
      try {
        this.isLoading = true;
        let result = await BookingService.saveConsigneeDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          document.activeElement.blur();
          this.$alertify.success("Recorded Successfully");
          let location = {
            id: this.bookingData.consingneecode,
            label: this.bookingData.consingneecode,
            consigneename: this.bookingData.consingneename,
            email: this.bookingData.consingneeemail,
            mobile:  this.bookingData.consingneemobile,
            telephone: this.bookingData.consingneetelephone,
            attn: this.bookingData.consingneeattn,
            csttin: this.bookingData.consingneecsttin,
            address: this.bookingData.consingneeaddress
          };
          let clientid;
          let pincode;
          //this.pushBookingDatatoManifest(this.bookingData.id);
          this.$refs.moveToNext.childMethod('subtab',3,clientid,pincode,location);
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveDetailedShipmentDetails(inputPayload){
      try {
        this.isLoading = true;
        let result = await BookingService.saveDetailedShipmentDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          document.activeElement.blur();
          this.$alertify.success("Recorded Successfully");
          //this.pushBookingDatatoManifest(this.bookingData.id);
          this.$refs.moveToNext.childMethod('subtab',4);
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveInvoiceAndGSTDetails(inputPayload){
      try {
        this.isLoading = true;
        let result = await BookingService.saveInvoiceAndGSTDetails(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          //this.pushBookingDatatoManifest(this.bookingData.id);
          document.activeElement.blur();
          this.$alertify.success("Recorded Successfully");
          this.$refs.moveToNext.childMethod('subtab',2);
        }else{
          let errData = result.data.data
          this.$refs.moveToNext.getInvalidInvoices(errData);
          document.activeElement.blur();
          let awbnumbers = []
          for (let index = 0; index < result.data.data.cargobookingdetails.length; index++) {
            awbnumbers.push(result.data.data.cargobookingdetails[index].awbnumber);
          }
          this.$alertify.error(result.data.message +" Already exists for awbs - "+ awbnumbers.join(", "));
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveValueAddedServices(inputPayload){
      try {
        this.isLoading = true;
        let result = await BookingService.saveValueAddedServices(inputPayload);
        this.isLoading = false;
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          //this.pushBookingDatatoManifest(this.bookingData.id);
          this.$alertify.success("Recorded Successfully");
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveBasicInformation(inputPayload,awbSeries,airCargoAmount){
      try {
        this.isLoading = true;
    		if(this.awbNo){
    		  let isvalid = await this.verifyawbseries(inputPayload.RouteMode,this.awbNo,awbSeries)
    		  if(!isvalid){
    			this.isLoading = false;
    			return false;
    		  }
    		  inputPayload.AWB = this.awbNo
    		}else if(this.checked){
    		  this.$alert("Please enter AWB Number", "", "error");
    		  this.isLoading = false;
    		  return false;
    		}
        let result = await BookingService.saveBasicInformation(inputPayload);
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          this.bookingid = this.bookingData.id;
          this.pushmanifestdataflag = this.bookingData.pushmanifestdataflag;
          this.awbNo = this.bookingData.awbnumber;
		      this.checkflag = true;
		      this.checked = false
          this.Status = CONSTANT.BOOKING_STATUS[this.bookingData.status];
          if (airCargoAmount) {
           let walletResponse = await this.deductPaymentFromWallet(airCargoAmount);
           if (walletResponse.valid == 1) {
            await this.pushBookingDatatoManifest(this.bookingData.id);
            await this.setRateCardData();
            this.$alert("AWB Generated", this.awbNo, "success");
            document.activeElement.blur();
            this.$refs.moveToNext.childMethod('maintab',2);
            this.getTraceIP(this.bookingData);
           }else{
            document.activeElement.blur();
            this.$alertify.error(walletResponse.message);
           }
          }else{
            await this.pushBookingDatatoManifest(this.bookingData.id);
            await this.setRateCardData();
            this.$alert("AWB Generated", this.awbNo, "success");
            document.activeElement.blur();
            this.$refs.moveToNext.childMethod('maintab',2);
            this.getTraceIP(this.bookingData);
          }
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
          if (airCargoAmount) {
            document.activeElement.blur();
            this.$alertify.error("Payment was not deducted from wallet");
          }
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async saveDetailedInformation(inputPayload){
      try {
        this.isLoading = true;
        let result = await BookingService.saveDetailedInformation(inputPayload);
        if (result.data.code == 200) {
          this.bookingData = result.data.data;
          inputPayload.BookingId = this.bookingData.id;
          inputPayload.pushmanifestdataflag = this.pushmanifestdataflag;
          await this.pushBookingDatatoManifest(this.bookingData.id, 'Complete');
          this.$alertify.success("Recorded Successfully");
          document.activeElement.blur();
          this.$emit("goBackToParent");
        }else{
          document.activeElement.blur();
          this.$alertify.error(result.data.message);
        }
        this.isLoading = false;
      } catch(err){
        this.isLoading = false;
        document.activeElement.blur();
        this.$alertify.error(err);
        console.log(err);
      }
    },
    saveBooking(input,type,awbSeries,airCargoAmount) {
      this.$validator.validateAll().then((result) => {
        if(result){
          if(this.bookingid){
            input.bookingid = this.bookingid;
          }
          input.clientid = this.client.ClientId;
          input.clientname = this.client.label;
          input.businessaccountname = this.businessaccountname;
          input.clientbusinessdetailid = this.clientbusinessdetailid;
          input.clientbusinessaccountid = this.clientbusinessaccountid;

          if(type=='saveServiceability'){
            input.ActiveContract = this.ActiveContract;
            this.saveServiceability(input,awbSeries);
          }else if(type=='savePickupLocation'){
            this.savePickupLocation(input,awbSeries);
          }else if(type=='saveShipmentDetails'){
            this.saveShipmentDetails(input,awbSeries);
          }else if(type=='saveConsigneeDetails'){
            this.saveConsigneeDetails(input);
          }else if(type=='saveDetailedShipmentDetails'){
            this.saveDetailedShipmentDetails(input);
          }else if(type=='saveInvoiceAndGSTDetails'){
            this.saveInvoiceAndGSTDetails(input);
          }else if(type=='saveValueAddedServices'){
            this.saveValueAddedServices(input);
          }else if(type=='saveBasicInformation'){
            input.ActiveContract = this.ActiveContract;
            this.saveBasicInformation(input,awbSeries,airCargoAmount);
          }else if(type=='saveDetailedInformation'){
            this.saveDetailedInformation(input);
          }else if(type=='saveShipmentTotal'){
            this.saveShipmentTotal(input);
          }else if(type=='saveShipmentDimensions'){
            this.saveShipmentDimensions(input);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    async pushBookingDatatoManifest(bookingid, status){
      try {
        let inputPayload = {};
        inputPayload.BookingId = bookingid;
        inputPayload.pushmanifestdataflag = this.pushmanifestdataflag;
        if(status){
          inputPayload.bookingstatus = status;
        }
        inputPayload.lastmodifiedby = this.userName;
        let result = await BookingService.pushBookingDatatoManifest(inputPayload);
      } catch(err){
        this.$alertify.error(err);
        console.log(err);
      }
    },
    async UploadFtcCashMemo (event){
      try{
      this.uploadFile = event.target.files[0];
      this.filename = event.target.files[0].name;
            if (this.uploadFile.size > (1024 * 1024 * 6)) {
              this.$alert(`Uploaded file size is greater than 6000KB`, "", "error");
              return false
            }
            this.$refs.files.value=null;
        }
        catch(err){
            this.isLoading = false
            console.log(err)
          }
   },
   async SaveFtcCashMemo (){
    try{
      let uploadformData = new FormData();
      this.isLoading = true
        uploadformData.append("file", this.uploadFile);
        uploadformData.append("awbnumber", this.bookingData.awbnumber);

      let uploadresult = await BookingService.UploadFtcCashMemo(uploadformData)
      if (uploadresult.data.errorCode == 0) {
        this.uploadedDoc = uploadresult.data.data
        let formData = new FormData();
        formData.append("awbnumber", this.bookingData.awbnumber);
        formData.append("ftccashmemo", this.uploadedDoc);
      let result = await BookingService.SaveFtcCashMemo(formData)
      if (result.data.code = 200) {
        this.$alertify.success("Document Saved successfully");
      }
      else{
        this.$alertify.error("Failed to save document.");
        this.isLoading = false
      }
      this.isLoading = false
      }
      else{
        this.$alertify.error("Document could not be uploaded.");
        this.isLoading = false
      }

  }
catch(err){
    this.isLoading = false
    console.log(err)
  }
},
async getFTCCashmemoDetails(){
  try{
    this.isLoading = true
    let inputPayload = {}
    inputPayload.awb =  this.bookingData.awbnumber;
    inputPayload.handovercheck =  this.bookingData.pickbyclient;
    let result = await BookingService.getFTCCashmemoDetails(inputPayload)
    console.log(result.data.code );
    if (result.data.code == 200) {
      if (result.data.message.iscashpayment == 0) {
        this.showCashMemoButton = false
      }else{
        this.showCashMemoButton = true
        if (result.data.message.cashmemoarray && result.data.message.cashmemoarray.length>0 ) {
          this.uploadedDoc = result.data.message.cashmemoarray[0]
        }else{
          if (this.bookingData.pickbyclient == 0) {
            this.downloadmessage = "Cash Memo Not Uploaded"
          }else{
          this.allowimageupload = true
          }
        }
      }
    }
    this.isLoading = false
}
catch(err){
  this.isLoading = false
  console.log(err)
}
},
  fileview(index){
    console.log(this.uploadFile);
    var link = document.createElement('a');
    link.href = index;
    link.setAttribute('target','_blank');
    window.open(index, '_blank');
    link.remove();
    return true;
  },
    showBookingType() {
      this.$emit("goBackToParent")
    },
    moveToNextPage(){
      let path = this.$router.resolve("/LRCopy")
      window.open(path.href, '_blank');
    },
		openPrintMPSModal(){
      this.PrintMPSModal = true;
      this.showMPSFlag = true;
    },
    closePrintMPSModal(){
       this.PrintMPSModal = false;
       this.showMPSFlag = false;
    },
    closeFtcModal(){
       this.FtcModal = false;
    },
    async openPrintAWBModal(){
       await this.getawbdetails();
       this.PrintAWBModal = true;
       this.showLRFlag = true;
    },
    openFtcModal(){
      if (this.bookingData.ftccashmemo) {
        this.uploadedDoc = this.bookingData.ftccashmemo
      }
       this.FtcModal = true;
    },
    clearFtcModal(){
       this.uploadFile = '';
       this.filename = '';
       this.uploadedDoc = '';
       this.$refs.files.value=null;
    },
    closePrintAWBModal(){
       this.PrintAWBModal = false;
    },
    async getawbdetails(){
      try {
       let payload = {
         'awb': [this.bookingData.awbnumber]
         }
         let result = await TripServices.getAWBDetailsForLRCopy(payload);
         let printMultipleAwbsLogs = [];
         let inputPayload ={}
         let dt = moment().tz('Asia/Kolkata').format('DD-MM-YYYY HH:mm:ss');
         if(result.data.code == 200){
         let awbdetails = result.data.data.awbdetails;
         let hubdetails = result.data.data.hubdetails;
         if(awbdetails.length > 0){
           for(const item of awbdetails){
           let pickupTime = "";
           if(item.PickupDetails.SlotsTime.From){
              pickupTime=item.PickupDetails.SlotsTime.From.slice(0,2)+":"+ item.PickupDetails.SlotsTime.From.slice(2,4)
           }

           let originhub;
           let destinationhubs;
           hubdetails.forEach(hubitem=>{
             if(item.OriginHubID==hubitem.HubID){
             originhub=hubitem.HubName;
             }
             if(item.DestinationHubId==hubitem.HubID){
             destinationhubs=hubitem.HubName
             }
           });

           //get sku dimensions list
           let dim = [];
           let qty = [];
           for(let i=0; i<5; i++){
             if(item.enabledimensionvisibilitylrcopy && item.SKUDetails && item.SKUDetails[i] && item.SKUDetails[i].BoxDimensions && item.clienttype!="SalesFranchise"){
               dim.push(item.SKUDetails[i].BoxDimensions);
             }else{
               dim[i] = "";
             }
             if(item.enabledimensionvisibilitylrcopy && item.SKUDetails && item.SKUDetails[i] && item.SKUDetails[i].NoOfBoxes && item.clienttype!="SalesFranchise"){
               qty.push(item.SKUDetails[i].NoOfBoxes);
             }else{
               qty[i] = "";
             }
           }

    		   let awbCustomiseData = {
        			"referenceno":item.referenceno,
        			"ConsigneeCode":item.DropDetails.Addresses[0].ConsigneeCode,
        			"consigneename":item.DropDetails.Addresses[0].Name,
        			"ConsigneePOC":item.DropDetails.Addresses[0].Attn,
        			"PickupLocation":item.PickupDetails.Addresses[0].Name,
        			"ClientReferenceNo":item.ClientReferenceNo,
        			"InvoiceNumber":item.InvoiceNumber,
        			"ebn":item.ebn,
        			"ConsigneeAddress":item.DropDetails.Addresses[0].Address,
              "PickupItemCount":(item.vtcamount)?item.vtcamount:""
    		    }
           this.LRCopyawbdata = {
             "awbnumber":item.parentawb,
             "originhub":null,
             "originhubid":item.OriginHubID,
             "destinationhubs":null,
             "destinationhubid":item.DestinationHubId,
             "clientid":item.ClientID,
             "clientbusinessacountid":item.clientbusinessacountid,
             "reliancesecondaryclient":item.reliancesecondaryclient,
             "businessaccountname":item.BusinessAccountName,
             "pickupname":item.PickupDetails.Addresses[0].Name,
             "pickupaddress":item.PickupDetails.Addresses[0].Address,
             "pickupcity":item.PickupDetails.Addresses[0].City,
             "pickuppincode":item.PickupDetails.Addresses[0].PinCode,
             "pickupmobile":item.PickupDetails.ContactDetails[0].PhoneNo,
             "pickupgst":item.PickupDetails.Addresses[0].TINNo,
             "pickupemail":item.PickupDetails.Addresses[0].EmailID,
             "requestedpickupdate":Util.displayDateOnlyFormat(item.PickupDetails.PickupSlotsDate),
             "requestedpickuptimefrom":pickupTime,
             "consingneecode":item.DropDetails.Addresses[0].ConsigneeCode,
             "consingneename":item.DropDetails.Addresses[0].Name,
             "consingneeattn":item.DropDetails.Addresses[0].Attn,
             "consingneeaddress":item.DropDetails.Addresses[0].Address,
             "consingneecity":item.DropDetails.Addresses[0].City,
             "destinationpincode":item.DropDetails.Addresses[0].PinCode,
             "consingneemobile":item.DropDetails.ContactDetails[0].PhoneNo,
             "consingneecsttin":item.DropDetails.Addresses[0].TINNo,
             "consingneeemail":item.DropDetails.Addresses[0].EmailID,
             "numberofmps":item.NumberOfMPS,
             "totalshipmentvalues":item.TotalInvoiceValue,
             "totalphysicalweight":item.totalphysicalweight,
             "totalvolumetricweight":item.VolumetricWeight,
             "bookingmode":item.BookingMode,
             "clientrefnumber":item.ClientReferenceNo,
             "refnumber":item.referenceno,
			       "dropbyclient":item.isshipmentdroptohubbyclient == 1?1:0,
			       "pickbyclient":item.isselfcollectbyclient == 1?1:0,
             "ebn":item.ebn,
             "originhub":originhub,
             "destinationhubs":destinationhubs,
             "clienttype": item.clienttype,
             "clientweightdisabledflag":item.clientweightdisabledflag,
			       "awbcopydata":awbCustomiseData,
             "enabledimensionvisibilitylrcopy":item.enabledimensionvisibilitylrcopy,
             "skuboxdimensions": dim,
             "skuboxquantity": qty,
             "bookingsource" : item.bookingsource
            }
             let awblogs ={
      				AWBNo: item.parentawb,
      				loggedinhubid : this.hubid,
      				userid : this.userid,
      				useremail : this.useremail,
      				hubName: this.hubname,
      				createdDate:dt,
      				sourceType: "Web"
      			}
      			printMultipleAwbsLogs.push(awblogs);
           };
           inputPayload.awblogs=printMultipleAwbsLogs
		       let  printawblogsresult= Report.printawblogs(inputPayload)
           }else{
           this.$alert("No Valid AWB(s) details found","","error");
           }
         }else{
         this.$alert("No Valid AWB(s) details found","","error");
         }
         this.isLoading=false;
      } catch (error) {
       this.isLoading = false
       console.log(error)
      }
    },
    printAWBPage() {
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           table {
               border-collapse: collapse;
               margin-left:0px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
      d.print(document.getElementById('printAWBData'), cssText);
    },
    getTraceIP(awbno) {
      let data =
        {
          "projectname": this.userdetail.project,
          "type": "web",
          "userid": this.userdetail.userid,
          "username": this.userdetail.username,
          "routeurl":'/Booking',
          "meta" : {
            "event" : `Booking`,
            "data" : awbno
          }
      }
      let result = iptracker.getTraceIP(data);
    },
    async setRateCardData(){
      if (this.bookingData.bookingmode == 'PrePaid' && this.bookingData.routemode == 'Air' && this.bookingData.awbnumber) {
        this.rateCardData = this.bookingData.prepaidratebreakup
        this.totalcharges = this.rateCardData.rate.basefreight
              + this.rateCardData.rate.originterminalcharges
              + this.rateCardData.rate.destinationterminalcharges
              + this.rateCardData.rate.originoperatorcharges
              + this.rateCardData.rate.destinationoperatorcharges
              + this.rateCardData.rate.othercharges
              + this.rateCardData.rate.extracharges

        this.gst = this.totalcharges / 100 *this.rateCardData.rate.gst ;
      }
    },
    async deductPaymentFromWallet(amount){
      try {

        let InputPayload = {
          customerId :this.bookingData.cbid,
          clientName : this.bookingData.clientname,
          clientid :this.bookingData.clientid,
          clientbusinessaccountid :this.bookingData.clientbusinessaccountid,
          bookingId :this.bookingData.id,
          amount :amount,
          createdby : this.userName
        };

        let result = await BookingService.deductPaymentFromWallet(InputPayload);
        if (result.data.code == 200) {
          return {valid : 1 ,message: result.data.message , data : result.data.data.transId}
        }else{
          return {valid : 0 ,message: result.data.message,data :null}
        }

      } catch (err) {
        console.log(err);
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/Createbookingtype/Createbookingtype.component.js